import type { ThemePreferenceType } from '@/styles/types';
import { THEME_PREFERENCES } from '@/styles/constants';
import { createContext } from 'react';

export interface ThemeContextValue {
  value: ThemePreferenceType;
  onChange: (next: ThemePreferenceType) => void;
  isPending: boolean;
  hasSyncError: boolean;
  retrySync: () => void;
}

export const ThemeContext = createContext<ThemeContextValue>({
  value: THEME_PREFERENCES.SYSTEM,
  onChange: () => {},
  isPending: false,
  hasSyncError: false,
  retrySync: () => {},
});
